export default __webpack_public_path__ + "static/media/message-received.fa4d9468.mp3";